export default __webpack_public_path__ + "static/flag-es-590802ab71f44d7bb996a2ae5a2398a9.svg";